import React, { Component} from 'react';
import {Link, withRouter} from 'react-router-dom';
import $ from 'jquery';

class Footer extends Component {

    componentDidMount() {
        $('.faq-button, .home-button').on('click', function () {
            $('.menuLink').removeClass('active');
          });
      
          $('.faq-button').on('click', function () {
            $('.faqLink').addClass('active');
          });
    }

    render() {
        const { location: {pathname}} = this.props; 
        const isApp = pathname ? pathname.includes('/app') : false;

        return(
        <div>
            { !isApp ? (
            <footer className="page-footer">
                <div className="top">
                    <div className="container-main">
                        <div className="wrapper">
                            <div className="logo">
                                <figure>
                                    <Link to='/' title="Nu INS" className="home-button">
                                        <img src="/img/logo-light.png" alt="Nu INS logo" onClick={ () => window.scrollTo(0,0)}></img>
                                    </Link>
                                </figure>
                            </div>
                            <div className="links">
                                <ul>
                                    <li>
                                        <a href="/files/Obshti-usloviya.pdf" target="_blank" rel="noopener">Общи условия</a>
                                    </li>
                                    <li>
                                        <a href="/files/Politika-za-biskvitkite.pdf" target="_blank" rel="noopener">Политика за бисквитките</a>
                                    </li>
                                    <li>
                                        <Link to="/privacy-policy" className="">Уведомление за поверителност</Link>
                                      
                                    </li>
                                    <li>
                                        <a href="https://forms.office.com/Pages/ResponsePage.aspx?id=bANGMJ12K0--GPUTUq42-eUxfkYYo8tBo300RnKnMgRUMEFCV0k3Q0Y1UFVBVUFJMENaMUZUOVdMVi4u"  target="_blank" rel="noopener">Изтриване на акаунт</a>
                                      
                                    </li>
                                </ul>
                                <ul>
                                    <li>
                                        <Link to="/faq" className="faq-button">Често задавани въпроси</Link>
                                    </li>
                                    <li>
                                        <a href="/files/Pri-intsident.pdf" target="_blank" rel="noopener">При инцидент</a>
                                    </li>
                                    <li>
                                        <a href="/files/Informatsiya-za-potrebitelya.pdf" target="_blank" rel="noopener">Информация за потребителя по чл. 325 от КЗ</a>
                                    </li>
                                </ul>
                                <ul>
                                    <li>
                                        <a href="/files/Ukazanie-za-popalvane-na-dvustranen-protokol-pri-PTP.pdf" target="_blank" rel="noopener">Указания за попълване на двустранен протокол при ПТП</a>
                                    </li>
                                    <li>
                                        <a href="/files/Popalnen-primeren-dvustranen-protokol-pri-PTP.pdf" target="_blank" rel="noopener">Попълнен примерен двустранен протокол при ПТП</a>
                                    </li>
                                    <li>
                                        <a href="/files/Dvustranen-protokol-pri-PTP.pdf" target="_blank" rel="noopener">Двустранен протокол при ПТП</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="bottom">
                    <div className="container-main">
                        <div className="wrapper">
                            <p className="copyright">
                            Nu INS e приложение, достъпно през браузър и мобилна апликация, разработено от “Мобайл Инс” ООД, ЕИК: 205899311, гр. София 1784, р-н Младост, бул. „Цариградско шосе” No111 П, ет.4, зона 2, Регистриран застрахователен брокер с удостоверение № 899-ЗБ / 30.11.2023 г., издадено от Комисията за Финансов Надзор.
                                <br />&copy; 2020 Nu INS
                            </p>
                            <div className="license">
                                <a href="/files/Udostoverenie.pdf">
                                    <img src="/img/footer-document-icon.png" alt="License PDF icon"></img>
                                    <div className="block">
                                        <span className="title">Удостоверение</span>
                                        <span className="link">Отвори файла</span>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>

        ) : null} 
        </div> 
        );
    }
};

export default Footer = withRouter(Footer);

  //<a href="/files/Uvedomlenie-za-poveritelnost.pdf" target="_blank" rel="noopener">Уведомление за поверителност</a>